import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import { $, add } from 'moneysafe';
import * as FS from '@fullstory/browser';
import { Modal, Spinner } from 'reactstrap';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import RentalPeriod from '../RentalPeriod/RentalPeriod';
import ColorOptionsMobileView from '../ColorOptionsMobileView/ColorOptionsMobileView';
import StorageOptionsMobieView from '../StorageOptionsMobieView/StorageOptionsMobieView';
import Button from 'containers/App/components/Button/Button';
import Cart from '../Cart/Cart';
import FormMessage from '../FormMessage';
import KnoxSecurity from 'layouts/CartLayout/KnoxSecurity/KnoxSecurity';
import DeliveryNInsurence from '../DeliveryNInsurence/DeliveryNInsurence';
import InsideBox from '../InsideBox/InsideBox';
import { notifType, notify } from 'utils/notifSender';
import TradeIn from '../TradeIn/TradeIn';
import Freebies from '../freebies/Freebies';
import S25Features from '../S25/Features/S25Features';

import { loginModal } from 'redux/reducers/auth';
import {
    addProductToCart,
    clearCart,
    toggleAddToCartEventFromStickyBottomBar,
    handleFetchingCart,
    triggerAddToCartEventFromOutside
} from 'redux/reducers/cart';
import { addItemsToCart, getUserCart } from 'api/cart';
import { trackKlaviyoEvent } from 'api/tracking';

import { ROUTES, STORAGEKEY_TRADE_IN_DEVICE, Q6B6_SLUGS, S25_SLUGS } from 'config/constants';
import content from 'assets/content/product.content.json';
import generalContent from 'assets/content/general.content.json';
import { convertToNumber, getSelectedStorageLabel, isSeptPromoValid, getAdjustedRRP } from 'utils/helpers';

import ShoppingCartWhite from 'assets/images/general/shopping-cart-white.svg';

import './BeforeBuy.scss';
import style from './BeforeBuy.module.scss';
import AutomaticOwnership from '../AutomaticOwnership/AutomaticOwnership';
import SamsungCarePlus from '../SamsungCarePlus/SamsungCarePlus';
import FreeDeliveryAndInstallation from '../FreeDeliveryAndInstallation/FreeDeliveryAndInstallation';

BeforeBuy.propTypes = {
    title: PropTypes.string.isRequired,
    priceDetails: PropTypes.string.isRequired,
    loginModal: PropTypes.func.isRequired,
    currency: PropTypes.string.isRequired,
    colors: PropTypes.array.isRequired,
    rentalOptions: PropTypes.array.isRequired,
    token: PropTypes.string.isRequired,
    addProductToCart: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    clearCart: PropTypes.func.isRequired,
    singpassStatus: PropTypes.string,
    attribute: PropTypes.array,
    selectedRentalPeriod: PropTypes.object,
    setSelectedRentalPeriod: PropTypes.func,
    selectedColor: PropTypes.object,
    setSelectedColor: PropTypes.func,
    selectedStorage: PropTypes.object,
    setSelectedStorage: PropTypes.func,
    images: PropTypes.array,
    colorsGallery: PropTypes.array,
    isAuthed: PropTypes.bool,
    setSelectedRentalPeriods: PropTypes.func,
    maxTradeInValue: PropTypes.number,
    isProductDA: PropTypes.bool
};

function BeforeBuy({
    title,
    currency,
    colors,
    token,
    rentalOptions,
    addProductToCart,
    product,
    singpassStatus,
    attribute,
    selectedRentalPeriod,
    setSelectedRentalPeriod,
    selectedColor,
    setSelectedColor,
    selectedStorage,
    setSelectedStorage,
    images,
    colorsGallery,
    setSelectedRentalPeriods,
    isAuthed,
    maxTradeInValue,
    isProductDA
}) {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const { slug } = useParams();
    const [openCart, setOpenCart] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [flag, setFlag] = useState(false);
    const elementRefForRentalSection = useRef(null);
    const [rentalPeriods, setRentalPeriods] = useState([]);
    const addToCartDispatch = JSON.parse(localStorage.getItem('currentCartItemPricingObj'));
    const { toggleAddToCartEvent } = useSelector(state => ({ toggleAddToCartEvent: state.cart.toggleAddToCartEvent }));
    const [rentalPeriod, setRentalPeriod] = useState(null);
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;
    const { cartItems, cartMeta, profile } = useSelector(state => ({
        profile: state.auth.profile,
        cart: state.cart.fetchedProducts,
        meta: state.cart.overview
    }));
    const durationTime = product.rental_period.find(rp => rp.id === selectedRentalPeriod?.id)?.duration_time;
    const tradeInDeviceLocalStorage = localStorage.getItem(STORAGEKEY_TRADE_IN_DEVICE);
    const tradeInDeviceLocalStorageObj = tradeInDeviceLocalStorage ? JSON.parse(tradeInDeviceLocalStorage) : null;
    const [tradeInApplied, setTradeInApplied] = useState(tradeInDeviceLocalStorageObj);
    const [retailPrice, setRetailPrice] = useState(getAdjustedRRP(product?.retail_value)?.toLocaleString('en-US'));

    const actionBarText = Q6B6_SLUGS.includes(slug) &&
        [12, 6, 3].includes(selectedRentalPeriod?.duration_time) &&
        isSeptPromoValid()
        ? <span className={`${tradeInDeviceLocalStorage ? 'duration__content' : ''} action-bar__text`}>20% OFF at Checkout</span> : <span className={`${tradeInDeviceLocalStorage ? 'duration__content' : ''} duration__value`}>{isProductDA ? 'SC+ Included' : 'FREE Damage Cover'}</span>;

    useEffect(() => {
        if (!openCart) {
            trackKlaviyoEvent('product-view', {
                email: profile.email,
                user_id: profile.id,
                title: title,
                product: [product],
                images: images[0].images,
                price: getPrice(profile?.is_student ? 'b2s' : 'b2c'),
                rentalPeriod: selectedRentalPeriod,
                selectedColor: selectedColor,
                selectedStorage: selectedStorage
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openCart, flag, selectedColor, selectedRentalPeriod, selectedStorage]);

    const getSelectedStorage = (product, attributeId) => {
        const attributes = product?.base_product?.attributes?.find(attribute => attribute.type === 'storage');

        return attributes?.attribute_values?.find(attribute => attribute.id === attributeId);
    };

    const sendUserCartData = async () => {
        try {
            const { data, meta } = await getUserCart();

            const formattedCartItems = data?.products?.map(item => ({
                ...item,
                selectedRentalPeriod: item?.rental_period,
                selectedColor: item?.color,
                selectedStorage: getSelectedStorage(item, item?.product_attribute_value_id)
            }));

            trackKlaviyoEvent('add-cart', {
                email: profile?.email,
                user_id: profile?.id,
                title: title,
                product: product,
                images: images[0].images,
                price: getPrice(profile?.is_student ? 'b2s' : 'b2c'),
                cartItems: formattedCartItems,
                cartMeta: meta,
                selectedRentalPeriod: selectedRentalPeriod,
                selectedColor: selectedColor,
                selectedStorage: selectedStorage
            });
        } catch (error) {
            Sentry.captureException(error);
        }
    };

    useEffect(() => {
        if (toggleAddToCartEvent) {
            setRentalPeriod(addToCartDispatch);
            handleAddToCart(addToCartDispatch?.data);
            dispatch(toggleAddToCartEventFromStickyBottomBar(false));

            if (token !== '') {
                history.push(ROUTES.CART);
            } else {
                history.push(ROUTES.SIGN_IN);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [toggleAddToCartEvent]);

    const reFetchCart = () => setFlag(!flag);

    const getSelectedRentalPeriod = (type) => {
        if (rentalPeriods?.length > 0) {
            return rentalPeriods?.find(rp => rp.user_type === type) ?? null;
        } else if (rentalOptions?.length > 0) {
            return rentalOptions?.find(rp => rp?.duration_time === selectedRentalPeriod?.duration_time && rp?.user_type === type) ?? null;
        }

        return null;
    };

    const getPrice = (type) => {
        let price = $(getSelectedRentalPeriod(type)?.price);

        if (selectedStorage && selectedStorage.item.price_impact) {
            const find = selectedStorage.item.price_impacts.find(e => e.rental_period_id === getSelectedRentalPeriod(type)?.id);

            if (find) {
                price = add($(price), $(find.price_impacts));
            }
        }

        return convertToNumber(price.toString())?.toLocaleString('en-US');
    };

    const handleRental = (i, duration) => {
        setRentalPeriods(i);
        setSelectedRentalPeriods(i);
        const selectedRentalTimePeriodAsObj = i.find(iR => iR?.duration_time === duration);

        setSelectedRentalPeriod(selectedRentalTimePeriodAsObj);
        localStorage.setItem('selectedRentalPeriod', JSON.stringify(selectedRentalTimePeriodAsObj));

        if (!isMobile) {
            if (elementRefForRentalSection.current) {
                elementRefForRentalSection.current.scrollIntoView({ behavior: 'smooth' });
            }
        }

        const searchParams = new URLSearchParams();

        searchParams.set('rental_term', selectedRentalTimePeriodAsObj?.duration_time);
        const updatedUrl = `${window.location.pathname}?${searchParams.toString()}`;

        window.history.replaceState(null, null, updatedUrl);
    };

    const isStudentPriceAvailable = () => {
        let studentObj = null;

        if (rentalPeriods?.length > 0) {
            studentObj = rentalPeriods?.find(rp => rp?.user_type === 'b2s');
        } else if (rentalOptions?.length > 0) {
            studentObj = rentalOptions?.find(rp => rp?.user_type === 'b2s');
        }

        return studentObj !== undefined && studentObj !== null;
    };

    const addToCart = (type) => {
        if (isAuthed) {
            const localStorageAccType = 'b2c';

            if (!isStudentPriceAvailable()) {
                if (localStorageAccType === null) {
                    localStorage.setItem('is_student', 'b2c');
                }

                setRentalPeriod(getSelectedRentalPeriod('b2c'));
                localStorage.setItem('previousProductPage', location.pathname);

                return;
            }

            if (localStorageAccType !== null) {
                switch (localStorageAccType) {
                    case 'b2s':
                        if (type === 'b2c') {
                            notify(content?.MESSAGES.B2C_ERROR, notifType.DANGER, 5000);
                        } else {
                            setRentalPeriod(getSelectedRentalPeriod(profile?.is_student ? 'b2s' : 'b2c'));
                        }

                        break;
                    case 'b2c':
                        if (type === 'b2s') {
                            notify(content?.MESSAGES.B2S_ERROR, notifType.DANGER, 5000);
                        } else {
                            setRentalPeriod(getSelectedRentalPeriod('b2c'));
                        }

                        break;
                    default:
                        break;
                }
            } else {
                const userType = 'b2c';

                switch (type) {
                    case 'b2c':
                        if (userType === 'b2s') {
                            notify(content?.MESSAGES.B2C_ERROR, notifType.DANGER, 5000);
                        } else {
                            localStorage.setItem('is_student', 'b2c');
                            setRentalPeriod(getSelectedRentalPeriod('b2c'));
                        }

                        break;
                    case 'b2s':
                        if (userType === 'b2c') {
                            notify(content?.MESSAGES.B2S_ERROR, notifType.DANGER, 5000);
                        } else {
                            localStorage.setItem('is_student', profile?.is_student ? 'b2s' : 'b2c');
                            setRentalPeriod(getSelectedRentalPeriod(profile?.is_student ? 'b2s' : 'b2c'));
                        }

                        break;
                    default:
                        break;
                }

                localStorage.setItem('previousProductPage', location.pathname);
            }
        } else {
            setRentalPeriod(getSelectedRentalPeriod('b2c'));

            localStorage.setItem('is_student', 'b2c');
            localStorage.setItem('previousProductPage', location.pathname);
        }
    };

    const handleAddToCart = async () => {
        let currentCartItem = null;

        currentCartItem = rentalPeriod;

        if (currentCartItem) {
            if (currentCartItem.id === -1) {
                notify(content?.MESSAGES.RENTAL_OPTION_MISSING, notifType.DANGER);

                return true;
            }

            if (colors.length !== 0 && !selectedColor) {
                notify(content?.MESSAGES.COLOR_OPTION_MISSING, notifType.DANGER);

                return true;
            }

            if (colors.length !== 0 && !isInStock(selectedColor)) {
                notify(content?.MESSAGES.SELECTED_VARIANT_OUT_OF_STOCK, notifType.DANGER);
                setRentalPeriod(null);

                return true;
            }

            if ((attribute && attribute.length !== 0 && Object.prototype.hasOwnProperty.call(attribute, 'attribute_storage'))) {
                if (!selectedStorage) {
                    notify(content?.MESSAGES.STORAGE_OPTION_MISSING, notifType.DANGER);

                    return true;
                }
            }

            if (token === '') {
                const baseProduct = { ...product };

                baseProduct.total = getPrice(currentCartItem?.user_type);

                addProductToCart({
                    ...product,
                    images,
                    currentCartItem,
                    selectedColor,
                    selectedStorage,
                    selectedRentalPeriod: currentCartItem,
                    total: baseProduct.total
                });

                FS.event('Product Added To Cart', {
                    product_id: product.id.toString(),
                    product_name: product.name,
                    product_attribute_value_id: selectedStorage ? selectedStorage.value
                        : (
                            product.attributes.specifications.values[0].value ||
                            product.attributes.inside_box.values[0].value
                        ),
                    quantity: '1',
                    rental_period: currentCartItem.duration_time,
                    color_id: selectedColor.value
                });

                baseProduct.medias = images[0].images;
            } else {
                const makeProducts = [];
                const keys = Object.keys(product.attributes);

                if ((product.attributes && keys.length > 0 && keys.includes('storage'))) {
                    const storageAttributes = product?.attributes?.storage?.values;

                    makeProducts.push(
                        {
                            is_purchase: false,
                            product_attribute_value_id: selectedStorage.value || storageAttributes[0]?.id,
                            quantity: 1,
                            rental_period_id: currentCartItem.id,
                            rental_period_duration: currentCartItem.duration_time,
                            product_id: product.id,
                            color_id: selectedColor.value,
                            deal_id: null
                        }
                    );
                } else {
                    makeProducts.push(
                        {
                            is_purchase: false,
                            product_attribute_value_id: (product.attributes.specifications.values[0].id || product.attributes.inside_box.values[0].id),
                            quantity: 1,
                            rental_period_id: currentCartItem.id,
                            rental_period_duration: currentCartItem.duration_time,
                            product_id: product.id,
                            color_id: selectedColor.value,
                            deal_id: null
                        }
                    );
                }

                setLoading(true);

                try {
                    await addItemsToCart(makeProducts);
                    const baseProduct = { ...product };

                    baseProduct.total = getPrice(currentCartItem?.user_type);

                    localStorage.removeItem('currentlySelectedCartItem');
                    dispatch(handleFetchingCart());

                    notify(content?.MESSAGES.ADDED_TO_CART, notifType.SUCCESS, 5000);

                    setOpenCart(true);

                    if ((product.attributes && keys.length > 0 && keys.includes('storage'))) {
                        const storageAttributes = product?.attributes?.storage?.values;

                        FS.event('Product Added To Cart', {
                            product_id: product.id.toString(),
                            product_name: product.name,
                            product_attribute_value_id: selectedStorage.value || storageAttributes[0]?.id,
                            quantity: '1',
                            rental_period: currentCartItem.duration_time,
                            color_id: selectedColor.value
                        });
                    } else {
                        FS.event('Product Added To Cart', {
                            product_id: product.id.toString(),
                            product_name: product.name,
                            product_attribute_value_id: (product.attributes.specifications.values[0].id || product.attributes.inside_box.values[0].id),
                            quantity: '1',
                            rental_period: currentCartItem.duration_time,
                            color_id: selectedColor.value
                        });
                    }

                    sendUserCartData();
                } catch (error) {
                    Sentry.captureException(error);
                }

                setLoading(false);
            }

            if (token !== '') {
                history.push(ROUTES.CART);
            } else {
                history.push(ROUTES.SIGN_IN);
            }
        }
    };

    const isInStock = (selectedColor) => {
        /* eslint-disable camelcase */
        const internalAsset = product?.internal_asset_codes?.find(({ product_attribute_value_id, color_id }) => (
            product_attribute_value_id === selectedStorage?.value &&
            color_id === selectedColor.value
        ));

        return internalAsset?.in_stock === 1;
    };

    useEffect(() => {
        if (rentalPeriod != null) {
            handleAddToCart();
            const payload = {
                toggle_event_called: true,
                data: rentalPeriod
            };

            dispatch(triggerAddToCartEventFromOutside(payload));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rentalPeriod]);

    useEffect(() => {
        localStorage.setItem('selectedColorOption', JSON.stringify(colorsGallery[0]));
    }, [colorsGallery]);

    useEffect(() => {
        setRetailPrice(Number(getAdjustedRRP(selectedStorage?.item?.meta?.retail_value))?.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }, [selectedStorage]);

    const submitCart = async () => {
        if (!singpassStatus || singpassStatus !== 'verified') {
            notify('Complete your profile first.', notifType.DANGER);

            history.push(ROUTES.CART);

            return;
        }

        if (singpassStatus === 'verified') {
            history.push(ROUTES.CART);
        }
    };

    const handleColor = e => {
        localStorage.setItem('selectedColorOption', JSON.stringify(e));
        setSelectedColor(e);
    };

    const handleStorage = e => setSelectedStorage(e);

    const updateTradeInData = (data) => setTradeInApplied(data);

    return (<div className={style.BeforeBuy}>
        {!isProductDA &&
            <div className='freebies-section'>
                <Freebies
                    product={product}
                    selectedRentalPeriod={selectedRentalPeriod}
                    maxTradeInValue={maxTradeInValue} />
            </div>}
        <h1 className={style.title}>{title}</h1>
        <p className={`${style.price} ${style.price__retail_value}`}>{generalContent?.RETAIL_PRICE}: <s>{currency} {retailPrice}</s></p>

        {!isMobile &&
            (
                !isProductDA
                    ? <>
                        <div className='knox-security-and-delivery-container'>
                            {!isProductDA &&
                                <div className='knox-security-section'>
                                    <KnoxSecurity />
                                </div>}

                            <div className='delivery-n-address-section'>
                                <DeliveryNInsurence productName={product?.name} productSlug={product?.slug} isProductDA={isProductDA} />
                            </div>
                        </div>
                    </>
                    : <>
                        <div className='da-tile-grid'>
                            <div className='da-tile'>
                                <SamsungCarePlus />
                            </div>
                            <div className='da-tile'>
                                <AutomaticOwnership />
                            </div>
                            <div className='da-tile'>
                                <FreeDeliveryAndInstallation />
                            </div>
                        </div>
                    </>
            )
        }

        {(attribute && attribute.length > 0 && attribute.some(e => e.item && e.item.key === 'attribute_storage')) &&
            <div ref={elementRefForRentalSection} className='storage__section-section '>
                <StorageOptionsMobieView
                    options={attribute}
                    selectedStorage={selectedStorage}
                    onClick={handleStorage}
                    productSlug={product?.slug}
                    isProductDA={isProductDA} />
            </div>}

        <div className='colors__section-section'>
            <ColorOptionsMobileView
                options={colors}
                selectedColor={selectedColor}
                colorsGallery={colorsGallery}
                images={images}
                onClick={handleColor} />
        </div>

        {rentalOptions.length !== 0 &&
            <div className='rental__period-section'>
                <RentalPeriod
                    rentalOptions={rentalOptions}
                    selected={selectedRentalPeriod}
                    onClick={handleRental} />
            </div>}

        {isMobile && product?.category?.name === 'Smartphones' && !isProductDA &&
            <div className='trade-in__section'>
                <TradeIn selectedDurationTime={durationTime} subtotal={Number(getPrice('b2c'))} updateTradeInData={updateTradeInData}
                    product={product} maxTradeInValue={maxTradeInValue} />
            </div>}

        {isMobile &&
            (
                !isProductDA
                    ? <>
                        <div className='knox-security-and-delivery-container'>
                            {!isProductDA &&
                                <div className='knox-security-section'>
                                    <KnoxSecurity />
                                </div>}

                            <div className='delivery-n-address-section'>
                                <DeliveryNInsurence productName={product?.name} productSlug={product?.slug} isProductDA={isProductDA} />
                            </div>
                        </div>
                    </>
                    : <>
                        <div className='da-tile-grid'>
                            <div className='da-tile'>
                                <SamsungCarePlus />
                            </div>
                            <div className='da-tile'>
                                <AutomaticOwnership />
                            </div>
                            <div className='da-tile'>
                                <FreeDeliveryAndInstallation />
                            </div>
                        </div>
                    </>
            )
        }

        {isMobile && !isProductDA &&
            <div className='inside-box-section'>
                <InsideBox
                    product={product}
                    selectedColor={selectedColor} />
            </div>}

        {rentalOptions.length !== 0 &&
            <div className='desktop-add-to-cart-section-container' style={{ maxWidth: '100vw' }}>
                <div className='desktop-add-to-cart-section container'>
                    <div className='desktop-add-to-cart-section__content d-flex'>
                        <div>
                            <p className='title'>
                                {title}<span className='desc'>{getSelectedStorageLabel(selectedStorage?.label, isProductDA)} | {selectedColor?.text}</span>
                            </p>
                            <p className='duration justify-content-between mb-0'>
                                <span className='duration__content'>{generalContent?.FOR}&nbsp;<span className='duration__value'>{selectedRentalPeriod?.duration_time} {generalContent?.MONTH}{selectedRentalPeriod.duration_time > 1 && 's'}</span></span>
                                {actionBarText}
                                {tradeInApplied && <span className='trade-in-applied trade-in-applied__mobile'>Trade-In Applied</span>}
                            </p>
                        </div>
                        {tradeInApplied && <span className='trade-in-applied trade-in-applied__desktop'>Trade-In Applied</span>}
                    </div>
                    <div className={`add-to-cart-buttons-container ${(getSelectedRentalPeriod('b2s') !== null || getSelectedRentalPeriod('b2c') !== '') && 'add-to-cart-buttons-container__single-column'}`}>
                        <div className='add-to-cart-buttons-container__container'>
                            <Button
                                disabled={loading}
                                loading={loading}
                                onClick={() => addToCart('b2c')}
                                title={loading ? <Spinner className='spinner' /> : <span
                                    className={style.addTocart__title}>
                                    {currency} {getPrice('b2c')}&nbsp;<span className={style.addTocart__title__month}>/mo</span>
                                    <img className='add-to-cart-buttons-container__container__cart-icon'
                                        src={ShoppingCartWhite} alt='Add to cart' />
                                </span>}
                                className={style.addTocart} />
                        </div>
                    </div>
                </div>
            </div>}

        {!isMobile && product?.category?.name === 'Smartphones' &&
            <div className='trade-in__section'>
                <TradeIn selectedDurationTime={durationTime} subtotal={Number(getPrice('b2c'))} updateTradeInData={updateTradeInData}
                    product={product} maxTradeInValue={maxTradeInValue} />
            </div>}

        {!isMobile && !isProductDA &&
            <div className='inside-box-section'>
                <InsideBox
                    product={product}
                    selectedColor={selectedColor} />
            </div>}
        {S25_SLUGS.includes(product?.slug) &&
            <div className='inside-box-section'>
                <S25Features slug={slug} />
            </div>}

        <Cart
            cartMeta={cartMeta}
            reFetchCart={reFetchCart}
            cartItems={cartItems}
            loading={loading}
            submitCart={submitCart}
            isOpen={openCart}
            toggle={() => setOpenCart(false)} />

        <Modal
            onClosed={() => setOpenModal(false)}
            className={style.modal}
            centered={true}
            isOpen={openModal}>
            <FormMessage />
        </Modal>
    </div>);
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginModal: openLogin => dispatch(loginModal(openLogin)),
        addProductToCart: product => dispatch(addProductToCart(product)),
        clearCart: () => dispatch(clearCart())
    };
};

export default connect(null, mapDispatchToProps)(BeforeBuy);
